import { request } from "../../api";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { Announcement } from "../../../../types/announcement.types";

const { get } = request;
const { Bearer } = AUTHORIZATION;
const initialRoute = "announcements";

type Params = {
	group_number: number;
	location_name: string;
	all_locations: boolean;
};

export const getAnnouncementByGroupAndLocation = async (params: Params): Promise<Announcement> => {
	try {
		const endpoint = `${initialRoute}/group-and-location`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				Authorization: `${Bearer} ${token}`
			},
			params
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const announcement = {
	getAnnouncementByGroupAndLocation
};
